// @ts-nocheck
/* Finetrack · GSAP / ScrollTrigger / Swiper · kv → explore */
(function () {
  'use strict';

  const TAG_NAME = 'finetrack-section';
  const FORM_SUBMIT_URL = 'https://ecf.cirkleinc.com/api/form-submit';
  const MOBILE_MQ = '(max-width: 1023.98px)';
  const FT_KV_NAV_ANCHOR_GAP = 8;
  const FT_KV_NAV_ANCHOR_EXTRA = 20;
  const FT_GRADIENT_ON = 'is-ft-gradient-on';
  const FT_AUTOPLAY_MS = 3000;
  const FT_AUTOPLAY_IN_VIEW_THRESHOLD = 0.12;
  const FT_TRAVEL_FADE_MS = 600;
  const FT_SWIPE_THRESHOLD = 48;
  const FT_SWIPE_SKIP_SEL = 'a, button, input, textarea, select, label';

  /** 全页滚动 / 淡入统一节奏：改此处即可同步各区块跟手速度 */
  const FT_MOTION = Object.freeze({
    reveal: {
      start: 'top 72%',
      y: 24,
      duration: 0.75,
      ease: 'power2.out',
      stagger: 0.14,
    },
    scrub: 0.68,
    scrubBand: {
      start: 'top 78%',
    },
    protection: {
      gradAt: 0.62,
      /** 动画结束约 top 34%；再向上滚一段距离作停留（勿 pin，避免大片留白） */
      animEndRatio: 0.34,
      endHoldRatio: 0.22,
      endHoldMin: 280,
    },
    highlights: {
      segmentRatio: 0.58,
      segmentMin: 420,
      stepDur: 1,
      endHoldRatio: 0.42,
      endHoldMin: 560,
    },
    sound: {
      /** 仅音量区块：PC 提速；手机保持原节奏 */
      scrub: 0.34,
      moStart: 'bottom bottom',
      moEnd: 'top 10%',
      glowPlayAt: 0.7,
      titleGradAt: 0.98,
      titleGradAtMo: 1.66,
      pinEndRatio: 1.35,
      pinMinPx: 820,
    },
  });

  const REVEAL = FT_MOTION.reveal;

  const MOTION_VISIBLE_SEL = [
    '[data-ft-pr-media]',
    '[data-ft-pr-copy]',
    '[data-ft-reveal]',
    '[data-ft-reveal-stagger] [data-ft-reveal]',
    '[data-ft-email-input-icon]',
  ].join(', ');

  let refreshRaf = 0;
  const ftScriptLoadCache = new Map();

  const scrollY = () => window.scrollY || window.pageYOffset || 0;
  const clamp = (n, min, max) => Math.max(min, Math.min(n, max));
  const prefersReduced = () =>
    window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;

  const scheduleRefresh = () => {
    const ST = window.ScrollTrigger;
    if (!ST?.refresh || refreshRaf) return;
    refreshRaf = requestAnimationFrame(() => {
      refreshRaf = 0;
      ST.refresh();
    });
  };

  const registerFtGsap = () => {
    const gsap = window.gsap;
    const ST = window.ScrollTrigger;
    if (!gsap || !ST) return false;
    gsap.registerPlugin(ST);
    const html = document.documentElement;
    if (html.dataset.ugFinetrackScrollSnapFix !== '1') {
      html.dataset.ugFinetrackScrollSnapFix = '1';
      html.style.scrollBehavior = 'auto';
    }
    return true;
  };

  const debounce = (fn, ms) => {
    let timer = 0;
    return (...args) => {
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        timer = 0;
        fn(...args);
      }, ms);
    };
  };

  const primeFtInlineVideo = (video, opts = {}) => {
    if (!(video instanceof HTMLVideoElement)) return;
    try {
      video.muted = true;
      video.defaultMuted = true;
      video.loop = opts.loop === true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('x5-playsinline', '');
      } catch (_) {}
  };

  const playFtInlineVideo = (video, callLoad, opts = {}) => {
    if (!(video instanceof HTMLVideoElement)) return;
    primeFtInlineVideo(video, opts);
    const run = () => {
      try {
        const p = video.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      } catch (_) {}
    };
    const schedule = () => window.requestAnimationFrame(() => window.requestAnimationFrame(run));
    if (video.readyState >= 2) {
      schedule();
      return;
    }
    const once = () => schedule();
    video.addEventListener('loadeddata', once, { once: true });
    if (callLoad) {
      try {
        video.load();
      } catch (_) {}
    }
  };

  const on = (ctx, target, type, handler, options) => {
    if (!target) return;
    if (typeof target.addEventListener === 'function') {
      target.addEventListener(type, handler, options);
      ctx.off.push(() => target.removeEventListener(type, handler, options));
      return;
    }

    // 兼容旧版 Safari 的 MediaQueryList（仅 addListener/removeListener）
    if (type === 'change' && typeof target.addListener === 'function') {
      target.addListener(handler);
      ctx.off.push(() => target.removeListener(handler));
    }
  };

  const createAbortController = () => {
    if (typeof AbortController === 'function') return new AbortController();
    // 旧环境降级：提供空 abort 能力，避免直接抛错
    return {
      signal: undefined,
      abort() {},
    };
  };

  const createCtx = () => ({
    off: [],
    gsap: window.gsap,
  });

  const needsFtMotion = (root) => {
    if (prefersReduced()) return false;
    return !!root.querySelector(
      '[data-ft-sound], [data-ft-highlights-stack], [data-ft-protection], [data-ft-scenarios], [data-ft-reveal], [data-ft-reveal-stagger]'
    );
  };

  const activateGradientsInRoot = (root) => activateGradient(root);

  const loadScriptOnce = (src, signal) =>
    new Promise((resolve, reject) => {
      if (signal?.aborted) return reject(new DOMException('Aborted', 'AbortError'));

      const cached = ftScriptLoadCache.get(src);
      if (cached) {
        cached.then(resolve).catch(reject);
        return;
      }

      const inDom = [...document.querySelectorAll('script[data-ft-src]')].find(
        (node) => node.getAttribute('data-ft-src') === src
      );
      if (inDom?.dataset.ftLoaded === '1') {
        ftScriptLoadCache.set(src, Promise.resolve());
        resolve();
        return;
      }

      const p = new Promise((res, rej) => {
        const s = inDom || document.createElement('script');
        if (!inDom) {
          s.src = src;
          s.defer = true;
          s.dataset.ftSrc = src;
        }

        const done = () => {
          s.removeEventListener('load', onLoad);
          s.removeEventListener('error', onErr);
          signal?.removeEventListener('abort', onAbort);
        };
        const onLoad = () => {
          s.dataset.ftLoaded = '1';
          done();
          res();
        };
        const onErr = () => {
          done();
          ftScriptLoadCache.delete(src);
          rej(new Error(`Finetrack script failed: ${src}`));
        };
        const onAbort = () => {
          done();
          if (!inDom) s.remove();
          ftScriptLoadCache.delete(src);
          rej(new DOMException('Aborted', 'AbortError'));
        };

        // 已存在但还没完成加载时，复用其事件
        s.addEventListener('load', onLoad);
        s.addEventListener('error', onErr);
        signal?.addEventListener('abort', onAbort, { once: true });
        if (!inDom) document.head.appendChild(s);
      });

      ftScriptLoadCache.set(src, p);
      p.then(resolve).catch(reject);
    });

  const ensureFtMotionLibs = async (root, signal) => {
    if (window.gsap && window.ScrollTrigger) {
      registerFtGsap();
      return true;
    }
    if (!needsFtMotion(root)) return false;
    const gsapUrl = root.dataset.ftGsap;
    const stUrl = root.dataset.ftScrolltrigger;
    if (!gsapUrl || !stUrl) return false;
    try {
      await loadScriptOnce(gsapUrl, signal);
      await loadScriptOnce(stUrl, signal);
      if (registerFtGsap()) return true;
    } catch (err) {
      if (err?.name !== 'AbortError') console.warn('Finetrack motion libs', err);
    }
    return false;
  };

  const needsFtSwiper = (root) => !!root.querySelector('[data-ft-travel-swiper]');

  const ensureFtSwiper = async (root, signal) => {
    if (typeof window.Swiper === 'function') return true;
    if (!needsFtSwiper(root)) return true;
    const swiperUrl = root.dataset.ftSwiper;
    if (!swiperUrl) return false;
    try {
      await loadScriptOnce(swiperUrl, signal);
      return typeof window.Swiper === 'function';
    } catch (err) {
      if (err?.name !== 'AbortError') console.warn('Finetrack Swiper', err);
    }
    return false;
  };

  const getRevealTrigger = (el, root) =>
    el.closest('section[id^="ft-"], [data-ft-kv], .ug-finetrack__editions') || root;

  const ensureSoundRevealImg = (revealWrap) => {
    const img = revealWrap?.querySelector('img');
    if (!(img instanceof HTMLImageElement)) return;
    const src = img.getAttribute('data-ft-src') || img.dataset.ftSrc;
    if (src && !img.getAttribute('src')) img.src = src;
    if (!img.complete && img.loading === 'lazy') img.loading = 'eager';
  };

  /** Slider / Swiper：进入视口再自动轮播，避免滚到区块前已播完 */
  const bindFtAutoplayInView = (hostEl, ctx, { onEnter, onLeave }) => {
    if (!(hostEl instanceof HTMLElement)) return;
    if (typeof IntersectionObserver !== 'function') {
      onEnter?.();
      return;
    }
    let inView = false;
    const io = new IntersectionObserver(
      (entries) => {
        const visible = entries.some((e) => e.isIntersecting);
        if (visible === inView) return;
        inView = visible;
        if (visible) onEnter?.();
        else onLeave?.();
      },
      { root: null, rootMargin: '0px 0px -8% 0px', threshold: FT_AUTOPLAY_IN_VIEW_THRESHOLD }
    );
    io.observe(hostEl);
    ctx.off.push(() => {
      io.disconnect();
      if (inView) onLeave?.();
    });
  };

  const bindSoundVideoPrime = (section, ctx) => {
    const video = section.querySelector('[data-ft-sn-glow-video]');
    if (!(video instanceof HTMLVideoElement)) return;
    if (typeof IntersectionObserver !== 'function') return;
    let primed = false;
    const prime = () => {
      if (primed) return;
      primed = true;
      try {
        video.preload = 'auto';
        video.load();
      } catch (_) {}
      io.disconnect();
    };
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) prime();
      },
      { rootMargin: '240px 0px', threshold: 0 }
    );
    io.observe(section);
    ctx.off.push(() => io.disconnect());
  };

  const runCleanups = (ctx) => {
    ctx.off.forEach((fn) => fn());
    ctx.off.length = 0;
  };

  const activateGradient = (target) => {
    if (!target) return;
    if (target instanceof HTMLElement && target.hasAttribute('data-ft-gradient-text')) {
      target.classList.add(FT_GRADIENT_ON);
      return;
    }
    target.querySelectorAll?.('[data-ft-gradient-text]').forEach((el) => el.classList.add(FT_GRADIENT_ON));
  };

  const setMotionVisible = (root, extraSel) => {
    const sel = extraSel ? `${MOTION_VISIBLE_SEL}, ${extraSel}` : MOTION_VISIBLE_SEL;
    root.querySelectorAll(sel).forEach((el) => {
          el.style.opacity = '1';
          el.style.transform = 'none';
    });
  };

  const onRevealComplete = (gsap, targets) => {
    gsap.utils.toArray(targets).forEach((el) => {
      if (!(el instanceof HTMLElement)) return;
      if (el.hasAttribute('data-ft-gradient-text')) el.classList.add(FT_GRADIENT_ON);
      if (el.hasAttribute('data-ft-reveal') && el.closest('.ug-finetrack__editions')) {
        gsap.set(el, { clearProps: 'transform' });
      }
    });
  };

  const getStaggerItems = (wrap) =>
    [...wrap.querySelectorAll(':scope [data-ft-reveal]')].filter((el) => {
        let p = el.parentElement;
      while (p && p !== wrap) {
        if (p.hasAttribute('data-ft-reveal')) return false;
          p = p.parentElement;
        }
      return p === wrap;
    });

  /* ---------- 滚动渐显 ---------- */

  function initScrollReveal(root) {
    if (!registerFtGsap()) return () => {};
    const gsap = window.gsap;
    const triggers = [];
    const from = { opacity: 0, y: REVEAL.y };
    const to = { opacity: 1, y: 0, duration: REVEAL.duration, ease: REVEAL.ease };
    const stOpts = { start: REVEAL.start, toggleActions: 'play none none none' };

    const shouldReveal = (el) => {
      if (el.closest('[data-ft-protection]')) return false;
      if (el.closest('[data-ft-sound]')) return false;
      if (!el.closest('[data-ft-highlights]')) return true;
      return window.matchMedia(MOBILE_MQ).matches;
    };

    const reveal = (targets, trigger) => {
      gsap.set(targets, from);
      const tween = gsap.to(targets, {
        ...to,
        stagger: REVEAL.stagger,
        scrollTrigger: { trigger, ...stOpts },
        onComplete: () => onRevealComplete(gsap, targets),
      });
      if (tween.scrollTrigger) triggers.push(tween.scrollTrigger);
    };

    const initProtectionReveal = () => {
      const section = root.querySelector('[data-ft-protection]');
      if (!section) return;

      const pr = FT_MOTION.protection;
      const media = section.querySelector('[data-ft-pr-media]');
      const copy = section.querySelector('[data-ft-pr-copy]');
      const gradEl = copy?.querySelector('[data-ft-gradient-text]');
      if (!media && !copy) return;

      const targets = [media, copy].filter(Boolean);
      gsap.set(targets, from);
      let gradOn = false;

      const syncPrGradient = (progress) => {
        if (!gradEl) return;
        if (progress >= pr.gradAt && !gradOn) {
          activateGradient(gradEl);
          gradOn = true;
        }
      };

      const prHoldScrollLen = () => Math.max(pr.endHoldMin, window.innerHeight * pr.endHoldRatio);
      const prScrollEnd = () => {
        const hold = prHoldScrollLen();
        const animEndTop = window.innerHeight * pr.animEndRatio;
        return `top ${Math.round(animEndTop - hold)}px`;
      };
      const prAnimDur = 0.78;
      const prHoldDur = 0.45;

      const tlPr = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: {
          trigger: section,
          start: FT_MOTION.scrubBand.start,
          end: prScrollEnd,
          scrub: FT_MOTION.scrub,
          invalidateOnRefresh: true,
          onUpdate: (self) => syncPrGradient(self.progress),
        },
      });

      if (media) tlPr.fromTo(media, from, { opacity: 1, y: 0, duration: 0.58 }, 0);
      if (copy) tlPr.fromTo(copy, from, { opacity: 1, y: 0, duration: 0.58 }, media ? 0.2 : 0);
      tlPr.to({}, { duration: prHoldDur }, prAnimDur);

      if (tlPr.scrollTrigger) triggers.push(tlPr.scrollTrigger);
    };

    if (prefersReduced()) {
      root.querySelectorAll('[data-ft-protection] [data-ft-gradient-text]').forEach((el) =>
        el.classList.add(FT_GRADIENT_ON)
      );
      setMotionVisible(root);
      return () => {};
    }

    initProtectionReveal();

    root.querySelectorAll('[data-ft-reveal-stagger]').forEach((wrap) => {
      const items = getStaggerItems(wrap).filter(shouldReveal);
      if (items.length) reveal(items, wrap);
    });

    const revealBuckets = new Map();
    root.querySelectorAll('[data-ft-reveal]').forEach((el) => {
      if (el.closest('[data-ft-reveal-stagger]') || !shouldReveal(el)) return;
      const trigger = getRevealTrigger(el, root);
      if (!revealBuckets.has(trigger)) revealBuckets.set(trigger, []);
      revealBuckets.get(trigger).push(el);
    });
    revealBuckets.forEach((items, trigger) => reveal(items, trigger));

    const emailIcons = [...root.querySelectorAll('[data-ft-email-input-icon]')];
    if (emailIcons.length) {
      const trigger =
        root.querySelector('[data-ft-kv]') ||
        emailIcons[0].closest('.ug-finetrack__email') ||
        root;
      gsap.set(emailIcons, { autoAlpha: 0, y: REVEAL.y, scale: 0.992 });
      const tween = gsap.to(emailIcons, {
        autoAlpha: 1,
        y: 0,
        scale: 1,
        duration: REVEAL.duration,
        ease: REVEAL.ease,
        stagger: 0.08,
        scrollTrigger: { trigger, start: REVEAL.start, once: true },
      });
      if (tween.scrollTrigger) triggers.push(tween.scrollTrigger);
    }

    scheduleRefresh();
    return () => triggers.forEach((st) => st.kill());
  }

  /* ---------- KV 粘性导航 ---------- */

  function initKvNav(root, ctx) {
    const nav = root.querySelector('[data-ft-kv-nav]');
    if (!(nav instanceof HTMLElement)) return;

    const kv = root.querySelector('[data-ft-kv]');
    const buyBtn = nav.querySelector('[data-ft-kv-nav-buy]');
    const buyTarget = root.querySelector('#ft-editions');

    let revealAt = 0;
    let scrollTick = false;

    const measureReveal = () => {
      if (!(kv instanceof HTMLElement)) return;
      revealAt = Math.max(0, Math.round(kv.getBoundingClientRect().bottom + scrollY()));
    };

    const showNav = () => {
      nav.classList.remove('is-ft-kv-nav-before', 'is-ft-kv-nav-sticky-leaving');
      nav.removeAttribute('aria-hidden');
      nav.classList.add('is-ft-kv-nav-sticky');
    };

    const hideNav = () => {
      nav.classList.remove('is-ft-kv-nav-sticky', 'is-ft-kv-nav-sticky-leaving');
      nav.classList.add('is-ft-kv-nav-before');
      nav.setAttribute('aria-hidden', 'true');
      requestAnimationFrame(measureReveal);
    };

    const onLeaveEnd = (ev) => {
      if (ev.target !== nav || ev.animationName !== 'ft-kv-nav-slide-out') return;
      nav.removeEventListener('animationend', onLeaveEnd);
      hideNav();
    };

    const startLeave = () => {
      if (!nav.classList.contains('is-ft-kv-nav-sticky') || nav.classList.contains('is-ft-kv-nav-sticky-leaving')) return;
      if (prefersReduced()) {
        hideNav();
        return;
      }
      nav.classList.add('is-ft-kv-nav-sticky-leaving');
      nav.addEventListener('animationend', onLeaveEnd);
    };

    const updateSticky = () => {
      scrollTick = false;
      const visible = scrollY() >= revealAt;

      if (nav.classList.contains('is-ft-kv-nav-sticky-leaving')) {
        if (visible) {
          nav.removeEventListener('animationend', onLeaveEnd);
          nav.classList.remove('is-ft-kv-nav-sticky-leaving');
          nav.classList.add('is-ft-kv-nav-sticky');
        }
        return;
      }

      if (visible) {
        if (!nav.classList.contains('is-ft-kv-nav-sticky')) showNav();
      } else if (nav.classList.contains('is-ft-kv-nav-sticky')) {
        startLeave();
      } else if (!nav.classList.contains('is-ft-kv-nav-before')) {
        hideNav();
      }
    };

    const queueSticky = () => {
      if (scrollTick) return;
      scrollTick = true;
      requestAnimationFrame(updateSticky);
    };

    measureReveal();
    queueSticky();

    on(ctx, window, 'scroll', queueSticky, { passive: true });
    on(ctx, window, 'resize', () => {
      measureReveal();
      queueSticky();
    }, { passive: true });

    ctx.off.push(() => {
      nav.removeEventListener('animationend', onLeaveEnd);
      nav.classList.remove('is-ft-kv-nav-sticky', 'is-ft-kv-nav-sticky-leaving', 'is-ft-kv-nav-before');
      nav.removeAttribute('aria-hidden');
    });

    const jumpTo = (el) => {
      const top = el.getBoundingClientRect().top + scrollY();
      const navH = nav.getBoundingClientRect().height;
      window.scrollTo({
        top: Math.max(0, top - navH - FT_KV_NAV_ANCHOR_GAP + FT_KV_NAV_ANCHOR_EXTRA),
        behavior: prefersReduced() ? 'auto' : 'smooth',
      });
    };

    const resolveAnchor = (href) => {
      const hash = href?.includes('#') ? href.slice(href.indexOf('#')) : '';
      if (!hash.startsWith('#')) return null;
      const el = root.querySelector(hash) || document.querySelector(hash);
      return el instanceof HTMLElement ? el : null;
    };

    nav.querySelectorAll('[data-ft-kv-nav-anchor]').forEach((el) => {
      on(ctx, el, 'click', (ev) => {
        const target = resolveAnchor(el.getAttribute('href') || '');
        if (!target) return;
        ev.preventDefault();
        jumpTo(target);
      });
    });

    if (buyBtn instanceof HTMLElement && buyTarget instanceof HTMLElement) {
      on(ctx, buyBtn, 'click', (ev) => {
        ev.preventDefault();
        jumpTo(buyTarget);
      });
    }
  }

  /* ---------- 系列卡 / Explore 产品卡 CTA ---------- */

  const EDITIONS_CTA_CFG = {
    buyLink: '[data-ft-editions-buy-link]',
    card: '[data-ft-editions-card]',
    productUrlAttr: 'data-ft-editions-product-url',
  };

  const EXPLORE_CTA_CFG = {
    buyLink: '[data-ft-explore-buy-link]',
    card: '[data-ft-explore-card]',
    productUrlAttr: 'data-ft-explore-product-url',
  };

  function initProductCta(scope) {
    if (!scope) return;
    scope.querySelectorAll('[data-ft-editions-cta], [data-ft-explore-cta]').forEach((zone) => {
      const cfg = zone.hasAttribute('data-ft-explore-cta') ? EXPLORE_CTA_CFG : EDITIONS_CTA_CFG;
      const label = zone.getAttribute('data-ft-buy-label')?.trim() || '';
      zone.querySelectorAll(cfg.buyLink).forEach((btn) => {
        if (label && btn instanceof HTMLElement) btn.textContent = label;
        if (btn instanceof HTMLAnchorElement) {
          const url = btn.closest(cfg.card)?.getAttribute(cfg.productUrlAttr);
          if (url) btn.href = url;
        }
      });
    });
  }

  function initEditions(root, ctx) {
    const editionsRoot = root.querySelector('.ug-finetrack__editions');
    if (!editionsRoot) return;
    initProductCta(editionsRoot);

    const btn = editionsRoot.querySelector('[data-ft-editions-mo-view-more]');
    if (btn instanceof HTMLButtonElement) {
      on(ctx, btn, 'click', () => {
        editionsRoot.classList.add('is-ft-mo-expanded');
        btn.setAttribute('aria-expanded', 'true');
        scheduleRefresh();
      });
    }
  }

  /* ---------- 核心场景 ---------- */

  function initScenarios(root, ctx) {
    const moMq = window.matchMedia(MOBILE_MQ);
    const { gsap } = ctx;

    root.querySelectorAll('[data-ft-scenarios]').forEach((section) => {
      const track = section.querySelector('[data-ft-scenarios-track]');
      const tabsEl = section.querySelector('[data-ft-scenarios-tabs]');
      const indicator = section.querySelector('[data-ft-scenarios-indicator]');
      const tabs = [...section.querySelectorAll('[data-ft-scenarios-tab]')];
      const panels = [...section.querySelectorAll('[data-ft-scenarios-panel]')];
      const descs = [...section.querySelectorAll('[data-ft-scenarios-desc]')];

      if (!(track instanceof HTMLElement) || !(tabsEl instanceof HTMLElement) || !(indicator instanceof HTMLElement) || !tabs.length) {
        return;
      }

      let index = 0;
      let isMo = moMq.matches;
      let sliderLock = false;
      let sliderTimer = 0;
      let trackRaf = 0;

      const syncIndicator = (tab, animate) => {
        const wrap = tabsEl.getBoundingClientRect();
        const box = tab.getBoundingClientRect();
        const pos = {
          left: box.left - wrap.left + tabsEl.scrollLeft,
          top: box.top - wrap.top + tabsEl.scrollTop,
          width: box.width,
          height: box.height,
        };
        if (animate && gsap && !prefersReduced()) {
          gsap.to(indicator, { ...pos, duration: 0.4, ease: 'power3.out', overwrite: true });
        } else if (gsap) {
          gsap.set(indicator, pos);
        }
      };

      const sliderScrollLeft = (i) => {
        const panel = panels[i];
        const target = panel.offsetLeft - (track.clientWidth - panel.offsetWidth) / 2;
        return clamp(target, 0, track.scrollWidth - track.clientWidth);
      };

      const scrollSlider = (i, smooth) => {
        const useSmooth = smooth && !prefersReduced();
        if (useSmooth) {
          sliderLock = true;
          clearTimeout(sliderTimer);
          sliderTimer = window.setTimeout(() => {
            sliderLock = false;
          }, 480);
        }
        track.scrollTo({ left: sliderScrollLeft(i), behavior: useSmooth ? 'smooth' : 'auto' });
      };

      const scrollTabBar = (tab, smooth) => {
        if (tabsEl.scrollWidth <= tabsEl.clientWidth) return;
        const target = tab.offsetLeft + tab.offsetWidth / 2 - tabsEl.clientWidth / 2;
        tabsEl.scrollTo({
          left: clamp(target, 0, tabsEl.scrollWidth - tabsEl.clientWidth),
          behavior: smooth && !prefersReduced() ? 'smooth' : 'auto',
        });
      };

      const setActive = (next, opts = {}) => {
        const i = clamp(next, 0, tabs.length - 1);
        const tab = tabs[i];
        const animate = !!opts.animate;
        const moveSlider = opts.scrollSlider !== false;
        const moveTab = opts.scrollTab !== false;

        index = i;

        tabs.forEach((el, j) => {
          const active = j === i;
          el.classList.toggle('is-ft-active', active);
          el.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        descs.forEach((el, j) => el.classList.toggle('is-ft-active', j === i));
        if (!isMo) panels.forEach((el, j) => el.classList.toggle('is-ft-active', j === i));

        requestAnimationFrame(() => syncIndicator(tab, animate));

        if (!isMo) return;
        if (moveTab) scrollTabBar(tab, animate);
        if (moveSlider) scrollSlider(i, animate);
      };

      tabs.forEach((tab, i) => {
        on(ctx, tab, 'click', () => {
          if (tab.classList.contains('is-ft-active')) return;
          setActive(i, { animate: true });
        });
      });

      on(ctx, tabsEl, 'scroll', () => syncIndicator(tabs[index], false), { passive: true });

      on(
        ctx,
        track,
        'scroll',
        () => {
          if (!isMo || sliderLock) return;
          cancelAnimationFrame(trackRaf);
          trackRaf = requestAnimationFrame(() => {
            const center = track.getBoundingClientRect().left + track.clientWidth / 2;
            let nearest = 0;
            let min = Infinity;
            panels.forEach((panel, j) => {
              const d = Math.abs(panel.getBoundingClientRect().left + panel.offsetWidth / 2 - center);
              if (d < min) {
                min = d;
                nearest = j;
              }
            });
            if (nearest !== index) setActive(nearest, { scrollSlider: false, animate: false });
          });
        },
        { passive: true }
      );

      ctx.off.push(() => {
        cancelAnimationFrame(trackRaf);
        clearTimeout(sliderTimer);
      });

      const relayout = () => {
        syncIndicator(tabs[index], false);
        if (isMo) {
          scrollSlider(index, false);
          scrollTabBar(tabs[index], false);
        }
      };

      on(ctx, window, 'resize', relayout, { passive: true });

      const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(relayout) : null;
      ro?.observe(tabsEl);
      ro?.observe(track);
      ctx.off.push(() => ro?.disconnect());

      const onMqChange = () => {
        isMo = moMq.matches;
        if (!isMo) track.scrollLeft = 0;
        setActive(index, { scrollSlider: isMo, scrollTab: isMo, animate: false });
        scheduleRefresh();
      };
      on(ctx, moMq, 'change', onMqChange);

      requestAnimationFrame(() => setActive(0, { scrollSlider: isMo, scrollTab: isMo, animate: false }));
    });
  }

  /* ---------- 三个卖点 ---------- */

  const HL_STACK = Object.freeze([
    { scale: 1, y: 0, dim: 0 },
    { scale: 0.937, y: -28, dim: 0.58 },
    { scale: 0.891, y: -56, dim: 0.78 },
  ]);
  const HL_ANCHOR = 0.0791;
  const HL_SCROLL = Object.freeze({
    scrub: FT_MOTION.scrub,
    segmentMin: FT_MOTION.highlights.segmentMin,
    segmentRatio: FT_MOTION.highlights.segmentRatio,
    stepDur: FT_MOTION.highlights.stepDur,
    endHoldMin: FT_MOTION.highlights.endHoldMin,
    endHoldRatio: FT_MOTION.highlights.endHoldRatio,
  });
  const SN_SCROLL = Object.freeze({
    scrub: FT_MOTION.sound.scrub,
    pinEndRatio: FT_MOTION.sound.pinEndRatio,
    pinMinPx: FT_MOTION.sound.pinMinPx,
    moStart: FT_MOTION.sound.moStart,
    moEnd: FT_MOTION.sound.moEnd,
    glowPlayAt: FT_MOTION.sound.glowPlayAt,
    titleGradAt: FT_MOTION.sound.titleGradAt,
    titleGradAtMo: FT_MOTION.sound.titleGradAtMo,
  });

  const snMoVw = (px) => `${((px / 375) * 100).toFixed(4)}vw`;

  const SN_MOTION = Object.freeze({
    copyHeadY: 28,
    copyNoteY: 12,
    wordPcFineX: -200,
    wordPcTrackX: 200,
    wordMoFineY: snMoVw(-72),
    wordMoTrackY: snMoVw(72),
    copyHeadMoY: snMoVw(28),
    copyNoteMoY: snMoVw(12),
  });

  /* ---------- 音量卖点 ---------- */

  function initSound(root, ctx) {
    const section = root.querySelector('[data-ft-sound]');
    if (!section) return;

    bindSoundVideoPrime(section, ctx);

    const moMq = window.matchMedia(MOBILE_MQ);
    let tl = null;
    let glowActive = false;
    let titleGradOn = false;

    const queryEls = () => {
      const copy = section.querySelector('[data-ft-sn-copy]');
      const wordFine = section.querySelector('[data-ft-sn-word-fine]');
      const wordTrack = section.querySelector('[data-ft-sn-word-track]');
      return {
        brand: section.querySelector('[data-ft-sn-brand]'),
        brandTrack: section.querySelector('[data-ft-sn-brand-track]'),
        wordFine,
        wordTrack,
        fineMotion: wordFine?.querySelector('[data-ft-sn-word-motion]'),
        trackMotion: wordTrack?.querySelector('[data-ft-sn-word-motion]'),
        deviceIntro: section.querySelector('[data-ft-sn-device-intro]'),
        deviceReveal: section.querySelector('[data-ft-sn-device-reveal]'),
        media: section.querySelector('[data-ft-sn-media]'),
        glow: section.querySelector('[data-ft-sn-glow]'),
        video: section.querySelector('[data-ft-sn-glow-video]'),
        copy,
        title: section.querySelector('[data-ft-gradient-text]'),
        head: copy?.querySelector('.ug-finetrack__sound-head') ?? null,
        lead: copy?.querySelector('.ug-finetrack__sound-lead') ?? null,
        note: section.querySelector('.ug-finetrack__sound-note'),
        noteMotion: section.querySelector('[data-ft-sn-note-motion]'),
      };
    };

    const pinTarget = section.querySelector('.ug-finetrack__sound-sticky') || section;
    const pinScrollLen = () =>
      Math.max(window.innerHeight * SN_SCROLL.pinEndRatio, SN_SCROLL.pinMinPx);
    const getTitleGradAt = (isMo) => (isMo ? SN_SCROLL.titleGradAtMo : SN_SCROLL.titleGradAt);

    const syncGlowVideo = (video, time) => {
      if (!(video instanceof HTMLVideoElement)) return;
      if (time >= SN_SCROLL.glowPlayAt) {
        if (!glowActive) {
          glowActive = true;
          try {
            video.currentTime = 0;
          } catch (_) {}
          // 循环播放；不在划回时间轴时 pause（避免「划走暂停」）
          playFtInlineVideo(video, true, { loop: true });
        }
        return;
      }
    };

    const syncTitleGradient = (title, time, isMo) => {
      if (!title) return;
      if (time >= getTitleGradAt(isMo) && !titleGradOn) {
        activateGradient(title);
        titleGradOn = true;
      }
    };

    const applyStatic = (els) => {
      section.classList.remove('is-ft-sn-animated');
      section.classList.add('is-ft-sn-static');
      activateGradient(els.title);
      ensureSoundRevealImg(els.deviceReveal);
      if (els.video) playFtInlineVideo(els.video, true, { loop: true });
    };

    const destroy = () => {
      tl?.scrollTrigger?.kill();
      tl?.kill();
      tl = null;
      glowActive = false;
      titleGradOn = false;
      section.classList.remove('is-ft-sn-animated', 'is-ft-sn-static', 'is-ft-sn-pinned');
      window.gsap?.set(
        section.querySelectorAll(
          '[data-ft-sn-word-motion], [data-ft-sn-note-motion], [data-ft-sn-device-intro], [data-ft-sn-device-reveal], [data-ft-sn-media], [data-ft-sn-glow], [data-ft-sn-copy], [data-ft-sn-brand], [data-ft-sn-brand-track], .ug-finetrack__sound-head, .ug-finetrack__sound-title, .ug-finetrack__sound-lead, .ug-finetrack__sound-note'
        ),
        { clearProps: 'opacity,visibility,scale,pointerEvents,x,y' }
      );
      section.querySelectorAll('[data-ft-gradient-text]').forEach((el) => el.classList.remove(FT_GRADIENT_ON));
      const glowV = section.querySelector('[data-ft-sn-glow-video]');
      if (glowV instanceof HTMLVideoElement) {
        try {
          glowV.pause();
          glowV.currentTime = 0;
        } catch (_) {}
      }
    };

    const build = () => {
      destroy();
      const gsap = ctx.gsap || window.gsap;
      const els = queryEls();
      const isMo = moMq.matches;

      if (!els.deviceIntro || !els.deviceReveal) return;

      if (!registerFtGsap() || prefersReduced() || !els.fineMotion || !els.trackMotion) {
        applyStatic(els);
        return;
      }

      const ST = window.ScrollTrigger;
      section.classList.add('is-ft-sn-animated');
      glowActive = false;
      titleGradOn = false;

      const introScaleStart = isMo ? 256 / 232 : 536 / 560;
      const wordOutFine = isMo
        ? { y: SN_MOTION.wordMoFineY, opacity: 0 }
        : { x: SN_MOTION.wordPcFineX, opacity: 0 };
      const wordOutTrack = isMo
        ? { y: SN_MOTION.wordMoTrackY, opacity: 0 }
        : { x: SN_MOTION.wordPcTrackX, opacity: 0 };

      gsap.set(els.deviceReveal, { visibility: 'visible', opacity: 0 });
      gsap.set(els.deviceIntro, {
        visibility: 'visible',
        opacity: 1,
        scale: introScaleStart,
        transformOrigin: '50% 50%',
      });
      gsap.set(els.media, { opacity: 0, visibility: 'hidden' });
      gsap.set(els.glow, { opacity: 0 });
      gsap.set([els.brand, els.brandTrack], { opacity: 1, visibility: 'visible' });
      gsap.set([els.fineMotion, els.trackMotion], { opacity: 1, x: 0, y: 0 });

      const copyHeadY = isMo ? SN_MOTION.copyHeadMoY : SN_MOTION.copyHeadY;
      const copyNoteY = isMo ? SN_MOTION.copyNoteMoY : SN_MOTION.copyNoteY;

      if (els.copy) {
        gsap.set(els.copy, { opacity: 0, visibility: 'hidden' });
        if (els.head) gsap.set(els.head, { opacity: 0, y: copyHeadY });
        if (els.title) gsap.set(els.title, { opacity: 0 });
        if (els.lead) gsap.set(els.lead, { opacity: 0 });
      }
      if (els.note) {
        gsap.set(els.note, { opacity: 0, visibility: 'hidden' });
        if (els.noteMotion) gsap.set(els.noteMotion, { y: copyNoteY });
      }

      const tlState = { current: null };

      const stCommon = {
        trigger: section,
        scrub: isMo ? FT_MOTION.scrub : SN_SCROLL.scrub,
        invalidateOnRefresh: true,
        onUpdate: () => {
          const time = tlState.current?.time() ?? 0;
          syncGlowVideo(els.video, time);
          syncTitleGradient(els.title, time, isMo);
        },
      };

      const scrollTrigger = isMo
        ? {
            ...stCommon,
            start: SN_SCROLL.moStart,
            end: SN_SCROLL.moEnd,
            pin: false,
          }
        : {
            ...stCommon,
            start: 'top top',
            end: () => `+=${pinScrollLen()}`,
            pin: pinTarget,
            pinSpacing: true,
            anticipatePin: 1,
            onToggle: (self) => section.classList.toggle('is-ft-sn-pinned', self.isActive),
          };

      tl = gsap.timeline({
        defaults: { ease: 'none', force3D: true },
        scrollTrigger,
      });
      tlState.current = tl;

      tl.to(els.fineMotion, { ...wordOutFine, duration: 0.38 }, 0)
        .to(els.trackMotion, { ...wordOutTrack, duration: 0.38 }, 0)
        .to(els.deviceIntro, { scale: 1, duration: 0.48 }, 0.04)
        .call(() => ensureSoundRevealImg(els.deviceReveal), null, 0.46)
        .to(els.deviceReveal, { opacity: 1, duration: 0.32 }, 0.52)
        .to([els.brand, els.brandTrack], { opacity: 0, duration: 0.2, pointerEvents: 'none' }, 0.54)
        .set([els.wordFine, els.wordTrack], { visibility: 'hidden' }, 0.58)
        .to(els.media, { opacity: 1, visibility: 'visible', duration: 0.38 }, 0.6)
        .to(els.glow, { opacity: 0.99, duration: 0.4 }, 0.66);

      if (els.copy) {
        // 视频层约淡入一半后再出文案（media 0.6→0.98 的中点 ≈0.79）
        const copyAt = isMo ? 1.14 : 0.79;
        tl.set(els.copy, { visibility: 'visible' }, copyAt)
          .to(els.head, { opacity: 1, y: 0, duration: 0.5 }, copyAt)
          .to(els.lead, { opacity: 1, duration: 0.42 }, copyAt + 0.1)
          .to(els.title, { opacity: 1, duration: 0.38 }, copyAt + 0.2)
          .to(els.copy, { opacity: 1, duration: 0.35 }, copyAt + 0.12);

        if (els.note && els.noteMotion) {
          tl.set(els.note, { visibility: 'visible' }, copyAt + 0.38)
            .to(els.note, { opacity: 1, duration: 0.4 }, copyAt + 0.38)
            .to(els.noteMotion, { y: 0, duration: 0.4 }, copyAt + 0.38);
        } else if (els.note) {
          tl.set(els.note, { visibility: 'visible' }, copyAt + 0.38).to(
            els.note,
            { opacity: 1, y: 0, duration: 0.4 },
            copyAt + 0.38
          );
        }
      }

      scheduleRefresh();
    };

    const onResize = debounce(() => {
      build();
      scheduleRefresh();
    }, 200);
    build();
    on(ctx, moMq, 'change', build);
    on(ctx, window, 'resize', onResize, { passive: true });
    ctx.off.push(() => destroy());
  }

  function initHighlights(root, ctx) {
    const section = root.querySelector('[data-ft-highlights]');
    const stack = root.querySelector('[data-ft-highlights-stack]');
    if (!section || !stack) return;

    const mq = window.matchMedia(MOBILE_MQ);
    let tl = null;

    const measureEnterY = () => {
      const stackH = stack.offsetHeight;
      const anchorTop = stackH * HL_ANCHOR;
      const sample = stack.querySelector('[data-ft-highlights-card]');
      const cardH = sample?.offsetHeight || Math.round(stackH * 0.92);
      const pinnedTop = (window.innerHeight - stackH) / 2;
      const rectTop = stack.getBoundingClientRect().top;
      const below = (top) => Math.ceil(window.innerHeight - (top + anchorTop) + cardH + 32);
      return Math.max(below(pinnedTop), below(rectTop), 1);
    };

    const hlCardDim = (card) => card.querySelector('[data-ft-hl-dim]');

    const destroy = () => {
      tl?.scrollTrigger?.kill();
      tl?.kill();
      tl = null;
      section.classList.remove('is-ft-hl-animated', 'is-ft-hl-static');
      window.gsap?.set(stack.querySelectorAll('[data-ft-highlights-card]'), {
        clearProps: 'transform,zIndex,opacity',
      });
      window.gsap?.set(stack.querySelectorAll('[data-ft-hl-dim]'), {
        clearProps: 'opacity',
      });
    };

    const build = () => {
      destroy();
      const gsap = window.gsap;
      const cards = [...stack.querySelectorAll('[data-ft-highlights-card]')];
      if (!cards.length) return;

      if (!registerFtGsap() || mq.matches || prefersReduced()) {
        section.classList.add('is-ft-hl-static');
        return;
      }

      const ST = window.ScrollTrigger;
      section.classList.add('is-ft-hl-animated');

      const enterY = measureEnterY();
      cards.forEach((card, i) => {
        gsap.set(card, {
          transformOrigin: '50% 0%',
          zIndex: i + 1,
          scale: 1,
          y: i ? enterY : 0,
          opacity: 1,
          force3D: true,
        });
        gsap.set(hlCardDim(card), { opacity: 0 });
      });

      const segmentLen = () =>
        Math.max(HL_SCROLL.segmentMin, window.innerHeight * HL_SCROLL.segmentRatio);
      const animScrollLen = () =>
        segmentLen() * Math.max(1, cards.length - 1) * HL_SCROLL.stepDur;
      const holdScrollLen = () =>
        Math.max(HL_SCROLL.endHoldMin, window.innerHeight * HL_SCROLL.endHoldRatio);
      const pinScrollLen = () => animScrollLen() + holdScrollLen();

      tl = gsap.timeline({
        defaults: { ease: 'none', force3D: true },
        scrollTrigger: {
          trigger: section,
          start: 'center center',
          end: () => `+=${pinScrollLen()}`,
          scrub: HL_SCROLL.scrub,
          pin: true,
          pinSpacing: true,
          anticipatePin: 1,
          invalidateOnRefresh: true,
        },
      });

      for (let step = 1; step < cards.length; step += 1) {
        const at = (step - 1) * HL_SCROLL.stepDur;

        tl.fromTo(cards[step], { y: enterY }, { y: 0, duration: HL_SCROLL.stepDur }, at);

        for (let i = 0; i < step; i += 1) {
          const from = HL_STACK[clamp(step - 1 - i, 0, HL_STACK.length - 1)];
          const to = HL_STACK[clamp(step - i, 0, HL_STACK.length - 1)];
          const dim = hlCardDim(cards[i]);
          tl.fromTo(
            cards[i],
            { scale: from.scale, y: from.y },
            { scale: to.scale, y: to.y, duration: HL_SCROLL.stepDur },
            at
          );
          if (dim) {
            tl.fromTo(dim, { opacity: from.dim }, { opacity: to.dim, duration: HL_SCROLL.stepDur }, at);
          }
        }
      }

      const animTimelineDur = Math.max(0, cards.length - 1) * HL_SCROLL.stepDur;
      const holdTimelineDur = () => {
        const a = animScrollLen();
        const h = holdScrollLen();
        if (!a) return 0.8;
        return animTimelineDur * (h / a);
      };
      if (animTimelineDur > 0) {
        tl.to({}, { duration: holdTimelineDur() }, animTimelineDur);
      }

      scheduleRefresh();
    };

    const onResize = debounce(build, 200);
    build();
    on(ctx, mq, 'change', build);
    on(ctx, window, 'resize', onResize, { passive: true });
    ctx.off.push(() => destroy());
  }

  /* ---------- travel · Swiper / media · 原生 slider ---------- */

  const isMobile = () => window.matchMedia(MOBILE_MQ).matches;

  const navPair = (prev, next) =>
    prev instanceof HTMLElement && next instanceof HTMLElement
      ? { prevEl: prev, nextEl: next }
      : undefined;

  const FT_NAV_DISABLED = 'is-ft-nav-disabled';

  const ftSwipeCanStart = (e) => !e.target.closest(FT_SWIPE_SKIP_SEL);

  function bindFtPointerSwipe(target, ctx, { onSwipeLeft, onSwipeRight }) {
    if (!(target instanceof HTMLElement)) return;
    let startX = 0;
    let startY = 0;
    let active = false;

    const endSwipe = (e) => {
      if (!active) return;
      active = false;
      try {
        target.releasePointerCapture(e.pointerId);
      } catch (_) {}
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      if (Math.abs(dx) < FT_SWIPE_THRESHOLD || Math.abs(dx) < Math.abs(dy) * 1.15) return;
      if (dx < 0) onSwipeLeft?.();
      else onSwipeRight?.();
    };

    on(ctx, target, 'pointerdown', (e) => {
      if (e.button !== undefined && e.button !== 0) return;
      if (!ftSwipeCanStart(e)) return;
      active = true;
      startX = e.clientX;
      startY = e.clientY;
      try {
        target.setPointerCapture(e.pointerId);
      } catch (_) {}
    });
    on(ctx, target, 'pointerup', endSwipe);
    on(ctx, target, 'pointercancel', () => {
      active = false;
    });
  }

  function setFtFadeMode(track, list, enabled) {
    track?.classList.toggle('is-ft-fade-mode', enabled);
    list?.classList.toggle('is-ft-fade-mode', enabled);
  }

  function applyFtFade(slides, list, index) {
    slides.forEach((slide, i) => {
      slide.classList.toggle('is-ft-active', i === index);
      slide.style.width = '';
      slide.style.marginRight = '';
    });
    if (list instanceof HTMLElement) {
      list.style.transform = '';
      list.style.transition = '';
    }
  }

  function syncFtNavBtns(prevBtns, nextBtns, atStart, atEnd) {
    prevBtns.forEach((btn) => {
      btn.classList.toggle(FT_NAV_DISABLED, atStart);
      btn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    });
    nextBtns.forEach((btn) => {
      btn.classList.toggle(FT_NAV_DISABLED, atEnd);
      btn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    });
  }

  function resetFtMoDotProgress(pagination) {
    if (!(pagination instanceof HTMLElement)) return;
    pagination.querySelectorAll('.is-ft-progress-run').forEach((el) => {
      el.classList.remove('is-ft-progress-run');
    });
    const active = pagination.querySelector(
      '.ug-finetrack__media-dot.is-ft-active, .ug-finetrack__explore-dot.is-ft-active'
    );
    if (!active) return;
    void active.offsetWidth;
    active.classList.add('is-ft-progress-run');
  }

  function createFtSlider(opts) {
    const {
      hostEl,
      track,
      list,
      slides,
      ctx,
      pagination,
      prevBtns = [],
      nextBtns = [],
      dotClass,
      autoplayVar,
      fade = false,
      minSlides = 1,
      dotsMobileOnly = false,
      canAutoplay = () => true,
      pauseUntilInView = true,
      getMetrics,
    } = opts;

    if (slides.length < minSlides) return null;

    const dotSel = dotClass.startsWith('.') ? dotClass : `.${dotClass}`;
    const viewHost = hostEl instanceof HTMLElement ? hostEl : null;

    let index = 0;
    let autoplayT = 0;
    let resizeT = 0;
    let autoplayOn = !fade;
    let inView = !pauseUntilInView;
    let wasMobile = isMobile();

    if (fade) setFtFadeMode(track, list, true);
    if (hostEl instanceof HTMLElement && autoplayVar) {
      hostEl.style.setProperty(autoplayVar, `${FT_AUTOPLAY_MS}ms`);
      if (fade) hostEl.style.setProperty('--ug-ft-fade-duration', `${FT_TRAVEL_FADE_MS}ms`);
    }

    const renderDots = () => {
      if (!(pagination instanceof HTMLElement) || (dotsMobileOnly && !isMobile())) return;
      pagination.innerHTML = '';
      slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = dotClass;
        dot.setAttribute('aria-label', `Slide ${i + 1}`);
        pagination.appendChild(dot);
      });
    };

    const syncDots = () => {
      if (!(pagination instanceof HTMLElement) || (dotsMobileOnly && !isMobile())) return;
      pagination.querySelectorAll(dotSel).forEach((dot, i) => {
        dot.classList.toggle('is-ft-active', i === index);
      });
      resetFtMoDotProgress(pagination);
    };

    const restartAutoplay = () => {
      clearInterval(autoplayT);
      if (prefersReduced() || slides.length < 2) return;
      if (fade && !autoplayOn) return;
      if (pauseUntilInView && !inView) return;
      if (!canAutoplay()) return;
      autoplayT = window.setInterval(() => {
        const { max } = getMetrics();
        goTo(index >= max ? 0 : index + 1);
      }, FT_AUTOPLAY_MS);
    };

    const setInView = (visible) => {
      inView = !!visible;
      if (inView) restartAutoplay();
      else clearInterval(autoplayT);
    };

    const apply = () => {
      const mobile = isMobile();
      if (dotsMobileOnly && mobile !== wasMobile) {
        wasMobile = mobile;
        if (mobile) renderDots();
        else if (pagination instanceof HTMLElement) pagination.innerHTML = '';
      }

      const { gap, slideW, max } = getMetrics();
      index = clamp(index, 0, max);

      if (fade) {
        applyFtFade(slides, list, index);
      } else {
        slides.forEach((slide) => slide.classList.remove('is-ft-active'));
        slides.forEach((slide, i) => {
          slide.style.width = `${slideW}px`;
          slide.style.marginRight = i === slides.length - 1 ? '0' : `${gap}px`;
        });
        list.style.transition = prefersReduced() ? 'none' : 'transform 0.4s ease';
        list.style.transform = `translate3d(${-(index * (slideW + gap))}px, 0, 0)`;
      }

      syncFtNavBtns(prevBtns, nextBtns, index <= 0, index >= max);
      syncDots();
      restartAutoplay();
    };

    const goTo = (i) => {
      index = clamp(i, 0, getMetrics().max);
      apply();
    };

    const step = (dir) => goTo(index + dir);

    const onStepClick = (e, dir) => {
      e.preventDefault();
      step(dir);
    };

    if (pagination instanceof HTMLElement) {
      on(ctx, pagination, 'click', (e) => {
        if (dotsMobileOnly && !isMobile()) return;
        const dot = e.target.closest(dotSel);
        if (!dot) return;
        const i = [...pagination.querySelectorAll(dotSel)].indexOf(dot);
        if (i >= 0) goTo(i);
      });
    }
    prevBtns.forEach((btn) => on(ctx, btn, 'click', (e) => onStepClick(e, -1)));
    nextBtns.forEach((btn) => on(ctx, btn, 'click', (e) => onStepClick(e, 1)));

    bindFtPointerSwipe(track, ctx, {
      onSwipeLeft: () => step(1),
      onSwipeRight: () => step(-1),
    });

    if (slides.length > 1) renderDots();
    apply();

    if (pauseUntilInView && viewHost) {
      bindFtAutoplayInView(viewHost, ctx, {
        onEnter: () => setInView(true),
        onLeave: () => setInView(false),
      });
    }

    on(ctx, window, 'resize', () => {
      clearTimeout(resizeT);
      resizeT = window.setTimeout(apply, 150);
    }, { passive: true });

    return {
      getIndex: () => index,
      goTo,
      open() {
        autoplayOn = true;
        apply();
      },
      close() {
        autoplayOn = false;
        clearInterval(autoplayT);
      },
      destroy() {
        clearTimeout(resizeT);
        clearInterval(autoplayT);
      },
    };
  }

  function initMediaSlider(root, ctx) {
    root.querySelectorAll('[data-ft-media]').forEach((section) => {
      const track = section.querySelector('[data-ft-media-track]');
      const list = section.querySelector('[data-ft-media-list]');
      if (!(track instanceof HTMLElement) || !(list instanceof HTMLElement)) return;

      const slides = [...list.querySelectorAll('[data-ft-media-item]')];
      const slider = createFtSlider({
        hostEl: section,
        track,
        list,
        slides,
        ctx,
        pagination: section.querySelector('[data-ft-media-pagination]'),
        prevBtns: [...section.querySelectorAll('[data-ft-media-prev-pc], [data-ft-media-prev-mo]')],
        nextBtns: [...section.querySelectorAll('[data-ft-media-next-pc], [data-ft-media-next-mo]')],
        dotClass: 'ug-finetrack__media-dot',
        autoplayVar: '--ug-ft-media-autoplay-duration',
        minSlides: 2,
        dotsMobileOnly: true,
        canAutoplay: () => isMobile(),
        getMetrics: () => {
          const mobile = isMobile();
          const gap = mobile ? 8 : 20;
          const perView = mobile ? 1 : Math.min(3, slides.length);
          const slideW = mobile
            ? Math.round(track.clientWidth * 0.8)
            : (track.clientWidth - gap * (perView - 1)) / perView;
          return { gap, slideW, max: Math.max(0, slides.length - perView) };
        },
      });
      if (!slider) return;

      section.classList.add('is-ft-media-slider-inited');
      ctx.off.push(() => {
        slider.destroy();
        section.classList.remove('is-ft-media-slider-inited');
      });
    });
  }

  function initTravelSwiper(root, ctx) {
    root.querySelectorAll('[data-ft-travel]').forEach((section) => {
      const el = section.querySelector('[data-ft-travel-swiper]');
      if (!(el instanceof HTMLElement)) return;
      if (el.querySelectorAll('.swiper-slide').length < 2) return;

      let swiper = null;
      let swiperWaitRaf = 0;
      let resizeT = 0;
      let inViewBound = false;

      const mount = () => {
        if (typeof window.Swiper !== 'function') return;
        try {
          swiper?.destroy(true, true);
      } catch (_) {}
        swiper = null;

        const reducedMotion = prefersReduced();
        const pagination = section.querySelector('[data-ft-travel-pagination]');
        try {
          swiper = new window.Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 0,
            effect: 'fade',
            fadeEffect: { crossFade: true },
            loop: true,
            loopAdditionalSlides: 1,
            speed: reducedMotion ? 0 : FT_TRAVEL_FADE_MS,
            watchOverflow: true,
            allowTouchMove: !reducedMotion,
            autoplay: reducedMotion
              ? false
              : {
                  delay: FT_AUTOPLAY_MS,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                  waitForTransition: true,
                },
            navigation: navPair(
              section.querySelector('[data-ft-travel-prev]'),
              section.querySelector('[data-ft-travel-next]')
            ),
            pagination:
              pagination instanceof HTMLElement
                ? {
                    el: pagination,
                    clickable: !reducedMotion,
                    bulletClass: 'ug-finetrack__travel-dot',
                    bulletActiveClass: 'is-ft-active',
                  }
                : undefined,
            on: {
              init: scheduleRefresh,
            },
          });
          section.classList.add('is-ft-travel-swiper-inited');
          if (!reducedMotion && swiper?.autoplay) swiper.autoplay.stop();
          if (!inViewBound) {
            inViewBound = true;
            bindFtAutoplayInView(section, ctx, {
              onEnter: () => swiper?.autoplay?.start(),
              onLeave: () => swiper?.autoplay?.stop(),
            });
          }
          scheduleRefresh();
        } catch (err) {
          console.warn('Finetrack travel Swiper', err);
        }
      };

      const onResize = () => {
        clearTimeout(resizeT);
        resizeT = window.setTimeout(() => {
          resizeT = 0;
          if (swiper) swiper.update();
          else mount();
        }, 200);
      };

      const bind = () => {
        mount();
        on(ctx, window, 'resize', onResize, { passive: true });
      };

      const waitForSwiper = (left = 120) => {
        if (typeof window.Swiper === 'function') {
          bind();
          return;
        }
        if (left <= 0) {
          console.warn('Finetrack travel Swiper: Swiper library not loaded');
          return;
        }
        swiperWaitRaf = requestAnimationFrame(() => {
          swiperWaitRaf = 0;
          waitForSwiper(left - 1);
        });
      };

      waitForSwiper();

      ctx.off.push(() => {
        clearTimeout(resizeT);
        if (swiperWaitRaf) cancelAnimationFrame(swiperWaitRaf);
        try {
          swiper?.destroy(true, true);
        } catch (_) {}
        swiper = null;
        section.classList.remove('is-ft-travel-swiper-inited');
      });
    });
  }

  /* ---------- 产品合集 ---------- */

  function initExplore(root, ctx) {
    const moMq = window.matchMedia(MOBILE_MQ);
    const isMo = () => moMq.matches;

    root.querySelectorAll('[data-ft-explore]').forEach((section) => {
      initProductCta(section);
      const dialog = section.querySelector('[data-ft-explore-dialog]');
      const points = [...section.querySelectorAll('[data-ft-explore-point]')];
      if (!dialog || !points.length) return;

      const track = dialog.querySelector('[data-ft-explore-mo-track]');
      const list = dialog.querySelector('[data-ft-explore-mo-list]');
      if (!(track instanceof HTMLElement) || !(list instanceof HTMLElement)) return;

      const slides = [...list.querySelectorAll('[data-ft-explore-mo-item]')];
      const moSlider = createFtSlider({
        hostEl: dialog,
        track,
        list,
        slides,
        ctx,
        pagination: dialog.querySelector('[data-ft-explore-mo-pagination]'),
        prevBtns: [...dialog.querySelectorAll('[data-ft-explore-mo-prev]')],
        nextBtns: [...dialog.querySelectorAll('[data-ft-explore-mo-next]')],
        dotClass: 'ug-finetrack__explore-dot',
        autoplayVar: '--ug-ft-explore-autoplay-duration',
        fade: true,
        pauseUntilInView: false,
        canAutoplay: () => !dialog.hidden,
        getMetrics: () => ({
          gap: 0,
          slideW: track.clientWidth,
          max: Math.max(0, slides.length - 1),
        }),
      });
      let lastFocus = null;
      let openPopPoint = null;

      const setPopOpen = (activePoint) => {
        if (isMo()) {
          if (openPopPoint) {
            openPopPoint.classList.remove('is-ft-pop-open');
            const prevBtn = openPopPoint.querySelector('[data-ft-explore-hotspot]');
            if (prevBtn instanceof HTMLButtonElement) prevBtn.setAttribute('aria-expanded', 'false');
            openPopPoint = null;
          }
          return;
        }
        const next =
          activePoint instanceof HTMLElement && points.includes(activePoint) ? activePoint : null;
        if (openPopPoint === next) return;

        if (openPopPoint) {
          openPopPoint.classList.remove('is-ft-pop-open');
          const prevBtn = openPopPoint.querySelector('[data-ft-explore-hotspot]');
          if (prevBtn instanceof HTMLButtonElement) prevBtn.setAttribute('aria-expanded', 'false');
        }

        openPopPoint = next;

        if (openPopPoint) {
          openPopPoint.classList.add('is-ft-pop-open');
          const btn = openPopPoint.querySelector('[data-ft-explore-hotspot]');
          if (btn instanceof HTMLButtonElement) btn.setAttribute('aria-expanded', 'true');
        }
      };

      const setHotspotsExpanded = (activeIndex) => {
        points.forEach((pt, i) => {
          const btn = pt.querySelector('[data-ft-explore-hotspot]');
          if (btn instanceof HTMLButtonElement) {
            btn.setAttribute('aria-expanded', activeIndex === i ? 'true' : 'false');
          }
        });
      };

      const preloadExplorePointMedia = (point) => {
        if (isMo() || !(point instanceof HTMLElement)) return;
        point.querySelectorAll('[data-ft-explore-pop] .ug-finetrack__explore-card-img').forEach((img) => {
          if (!(img instanceof HTMLImageElement) || img.dataset.ftPreloaded === '1') return;
          img.dataset.ftPreloaded = '1';
          const src = img.currentSrc || img.src;
          if (src && !img.complete) {
            const pre = new Image();
            pre.decoding = 'async';
            pre.src = src;
          }
        });
      };

      let pcHoverBound = false;
      const bindPcPopHover = () => {
        if (pcHoverBound) return;
        pcHoverBound = true;
        const leaveTs = points.map(() => 0);
        const enterRaf = points.map(() => 0);
        points.forEach((point, i) => {
          const enter = () => {
            if (isMo()) return;
            clearTimeout(leaveTs[i]);
            leaveTs[i] = 0;
            preloadExplorePointMedia(point);
            if (enterRaf[i]) return;
            enterRaf[i] = requestAnimationFrame(() => {
              enterRaf[i] = 0;
              setPopOpen(point);
            });
          };
          const leave = (e) => {
            if (isMo()) return;
            if (enterRaf[i]) {
              cancelAnimationFrame(enterRaf[i]);
              enterRaf[i] = 0;
            }
            const next = e.relatedTarget;
            if (next instanceof Node && point.contains(next)) return;
            clearTimeout(leaveTs[i]);
            leaveTs[i] = window.setTimeout(() => setPopOpen(false), 280);
          };
          on(ctx, point, 'mouseenter', enter);
          on(ctx, point, 'mouseleave', leave);
        });
        setPopOpen(false);
        ctx.off.push(() => {
          leaveTs.forEach((t) => clearTimeout(t));
          enterRaf.forEach((r) => r && cancelAnimationFrame(r));
        });
      };

      bindPcPopHover();
      if (isMo()) setPopOpen(false);

      const closeDialog = () => {
        if (dialog.hidden) return;
        moSlider?.close();
        dialog.hidden = true;
        section.classList.remove('is-ft-explore-dialog-open');
        document.documentElement.classList.remove('is-ft-explore-dialog-open');
        setHotspotsExpanded(-1);
        lastFocus?.focus?.();
        lastFocus = null;
      };

      const openDialog = (slideIndex) => {
        if (!isMo()) return;
        lastFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        dialog.hidden = false;
        section.classList.add('is-ft-explore-dialog-open');
        document.documentElement.classList.add('is-ft-explore-dialog-open');
        setHotspotsExpanded(slideIndex);
        moSlider?.goTo(slideIndex);
        moSlider?.open();
        scheduleRefresh();
      };

      points.forEach((point, i) => {
        const btn = point.querySelector('[data-ft-explore-hotspot]');
        if (!(btn instanceof HTMLButtonElement)) return;
        on(ctx, btn, 'click', (e) => {
          if (!isMo()) return;
          e.preventDefault();
          if (!dialog.hidden && moSlider?.getIndex() === i) {
            closeDialog();
            return;
          }
          openDialog(i);
        });
      });

      const isMoDialogKeepOpen = (target) =>
        target instanceof Element &&
        !!target.closest(
          '[data-ft-explore-card], [data-ft-explore-mo-prev], [data-ft-explore-mo-next], [data-ft-explore-mo-pagination], .ug-finetrack__explore-dot, .ug-finetrack__explore-nav-btn'
        );

      on(ctx, dialog, 'click', (e) => {
        if (!isMo() || dialog.hidden) return;
        if (isMoDialogKeepOpen(e.target)) return;
        closeDialog();
      });

      on(ctx, document, 'keydown', (e) => {
        if (e.key === 'Escape' && !dialog.hidden) {
          e.preventDefault();
          closeDialog();
        }
      });

      on(ctx, moMq, 'change', () => {
        if (!isMo()) bindPcPopHover();
        closeDialog();
        setPopOpen(false);
      });

      ctx.off.push(() => {
        closeDialog();
        moSlider?.destroy();
      });
    });
  }

  /* ---------- 各区块交互初始化（KV/系列/场景/音量/卖点/Travel/媒体/Explore） ---------- */

  function initFeatures(root) {
    registerFtGsap();
    const ctx = createCtx();
    initKvNav(root, ctx);
    initEditions(root, ctx);
    initScenarios(root, ctx);
    initSound(root, ctx);
    initHighlights(root, ctx);
    initTravelSwiper(root, ctx);
    initMediaSlider(root, ctx);
    initExplore(root, ctx);
    return () => runCleanups(ctx);
  }

  /* ---------- 邮件订阅 ---------- */

  const EMAIL_RE =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  function isValidEmail(value) {
    return EMAIL_RE.test(String(value).toLowerCase());
  }

  class FinetrackSection extends HTMLElement {
    #revealCleanup = null;
    #featureCleanup = null;
    #bootAbort = null;

    connectedCallback() {
      if (this.dataset.ftInited === '1') return;
      this.dataset.ftInited = '1';
      this.#boot();
    }

    async #boot() {
      this.#bootAbort?.abort();
      const ac = createAbortController();
      this.#bootAbort = ac;

      this.querySelectorAll('[data-ft-email]').forEach((block) => this.#bindEmail(block));

      if (prefersReduced()) {
        setMotionVisible(this);
        activateGradientsInRoot(this);
        await ensureFtSwiper(this, ac.signal);
        if (ac.signal.aborted || this.dataset.ftInited !== '1') return;
        this.#featureCleanup = initFeatures(this);
        return;
      }

      const motionOk = await ensureFtMotionLibs(this, ac.signal);
      if (ac.signal.aborted || this.dataset.ftInited !== '1') return;

      await ensureFtSwiper(this, ac.signal);
      if (ac.signal.aborted || this.dataset.ftInited !== '1') return;

      this.#featureCleanup = initFeatures(this);
      if (motionOk) {
        this.#revealCleanup = initScrollReveal(this);
      } else {
        setMotionVisible(this);
        activateGradientsInRoot(this);
      }
    }

    disconnectedCallback() {
      this.#bootAbort?.abort();
      this.#bootAbort = null;
      this.#revealCleanup?.();
      this.#featureCleanup?.();
      this.#revealCleanup = null;
      this.#featureCleanup = null;
      delete this.dataset.ftInited;
      this.querySelectorAll('[data-ft-email]').forEach((el) => {
        if (el instanceof HTMLElement) el._ftEmailAbort?.abort();
        delete el.dataset.ftEmailInited;
      });
    }

    #bindEmail(block) {
      if (!(block instanceof HTMLElement) || block.dataset.ftEmailInited === '1') return;
      block.dataset.ftEmailInited = '1';
      block._ftEmailAbort?.abort();
      const ac = createAbortController();
      block._ftEmailAbort = ac;
      const { signal } = ac;

      const submit = block.querySelector('.ug-finetrack__email-submit');
      const input = block.querySelector('.ug-finetrack__email-input');
      const privacy = block.querySelector('.ug-finetrack__email-checkbox');
      const errorEl = block.querySelector('.ug-finetrack__email-error');
      const successEl = block.querySelector('.ug-finetrack__email-message');

      if (!(submit instanceof HTMLButtonElement) || !(input instanceof HTMLInputElement)) return;

      const formId = block.getAttribute('data-form-id') || '';
      const texts = {
        success: block.getAttribute('data-success-text') || 'Thanks for subscribing!',
        fail: block.getAttribute('data-fail-text') || 'Subscription failed, please try again later.',
        privacy: block.getAttribute('data-privacy-error') || 'Please agree to the privacy policy.',
        email: block.getAttribute('data-email-error') || 'Please enter a valid email address.',
      };

      const showError = (msg) => {
        if (errorEl) {
          errorEl.textContent = msg;
          errorEl.style.display = 'block';
        }
        if (successEl) successEl.style.display = 'none';
      };

      const showSuccess = (msg) => {
        if (successEl) {
          successEl.textContent = msg;
          successEl.style.display = 'block';
        }
        if (errorEl) errorEl.style.display = 'none';
      };

      const trackGa = (ok) => {
        window.ugGa4Track?.subscriptionEvent?.({ isSuccess: ok, position: 'finetrack' });
      };

      submit.addEventListener('click', async () => {
        const email = input.value.trim();
        if (!isValidEmail(email)) return showError(texts.email);
        if (privacy instanceof HTMLInputElement && !privacy.checked) return showError(texts.privacy);
        if (submit.classList.contains('loading')) return;

        errorEl && (errorEl.style.display = 'none');
        successEl && (successEl.style.display = 'none');
        submit.classList.add('loading');

        try {
          const res = await fetch(FORM_SUBMIT_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              email,
              accepts_marketing: privacy instanceof HTMLInputElement && privacy.checked ? 'on' : 'off',
              form_id: formId,
            }),
            signal,
          });

          let data;
          try {
            data = await res.json();
          } catch {
            showError(texts.fail);
            trackGa(false);
            return;
          }

          if (data?.status === 'success') {
            input.value = '';
            showSuccess(texts.success);
            trackGa(true);
          } else {
            showError(data?.errors?.email?.[0] || data?.message || texts.fail);
            trackGa(false);
          }
        } catch (err) {
          // 区块卸载时 AbortController 会中止请求，不提示失败
          if (err && typeof err === 'object' && err.name === 'AbortError') return;
          showError(texts.fail);
          trackGa(false);
        } finally {
          submit.classList.remove('loading');
        }
      }, { signal });

      input.addEventListener(
        'keydown',
        (e) => {
          if (e.key === 'Enter') {
          e.preventDefault();
            submit.click();
        }
        },
        { signal }
      );
    }
  }

  if (!customElements.get(TAG_NAME)) {
  customElements.define(TAG_NAME, FinetrackSection);
  }

    if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      document.documentElement.classList.add('ug-finetrack-page--ready');
    }, { once: true });
    } else {
    document.documentElement.classList.add('ug-finetrack-page--ready');
  }
})();
